import styled from 'styled-components';

import JourneyEmptyStateImage from './journey.png';

const Wrapper = styled.div`
	width: 300px;
`;

export default function JourneyEmptyState() {
	return (
		<Wrapper>
			<img
				style={{ maxWidth: '100%', maxHeight: '100%' }}
				src={JourneyEmptyStateImage}
				alt="No journey found."
			/>
		</Wrapper>
	);
}
